import type { ENVType } from '@/types/ENV'

export default {
  APP_URL: 'https://playerrating-rbac.solaireresort.com/',

  // make sure to end url with a '/'
  API_URL: 'https://playerrating-api-rbac.solaireresort.com/',
  MSAL_TENANT_ID: '9c1d6af6-94df-4a4c-9b70-26edaee05a21',
  MSAL_CLIENT_ID: 'fc2e9705-a5c5-45f8-988b-b63ee22c7947',
  MSAL_REDIRECT_URI: '/',
  MSAL_POST_LOGOUT_REDIRECT_URI: '/',
  USE_KONG_API: false,
  TOKEN_API_URL: '',
  TOKEN_API_CLIENT_ID: '',
  TOKEN_API_CLIENT_SECRET: ''
} as ENVType
